import './styles.css';

import { GatsbyBrowser , Script } from 'gatsby';
import React from 'react';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  const isDownloadPath = props.location.pathname.includes('/downloads');

  return (
    <>
      {element}
      {!isDownloadPath && (
        <>
          <Script
            id="hs-script-loader"
            src="https://js-eu1.hs-scripts.com/25768951.js"
            strategy="idle"
          />
          <Script
            id="hs-script-web-interactive"
            src="https://js.hubspot.com/web-interactives-embed.js"
            strategy="idle"
            onLoad={() => {
              if (typeof window !== 'undefined') {
                // @ts-ignore
                window.hubspot_web_interactives_running = false;
              }
            }}
          />
        </>
      )}
    </>
  );
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = async ({ location }) => {
  // @ts-ignore
  if (typeof window !== 'undefined' && window._hsq) {
    // @ts-ignore
    window._hsq.push(['trackPageView']);
  }

  if (location.pathname.includes('/downloads')) {
    const elementsToRemove = [
      'hs-script-web-interactive',
      'hs-web-interactives-top-push-anchor',
      'hs-web-interactives-top-anchor',
      'hs-web-interactives-bottom-anchor',
      'hs-web-interactives-floating-container',
    ];

    elementsToRemove.forEach((id) => {
      document.getElementById(id)?.remove();
    });
  }
  const legacyUrl = process.env.DRUPAL_LEGACY_URL || 'https://www2.knime.com';
  await fetch(legacyUrl + location.pathname, {
    cache: 'no-cache',
    headers: {
      'X-Referer': window.document.referrer,
      Referer: window.document.referrer,
    },
    referrerPolicy: 'unsafe-url',
  });
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = (
  args,
) => {
  // Tell Gatsby to only update scroll position if the pathname or hash has changed.
  // If only the search has changed (e.g. when a search form is submitted),
  // the scroll position should remain the same.
  const current = args.routerProps.location;
  const previous = args.prevRouterProps?.location;
  return (
    current.pathname !== previous?.pathname || current.hash !== previous?.hash
  );
};
